import { useEffect } from 'react'
import { useBlogCms } from '@/hooks/useBlogCms'
import { useRouter } from 'next/router'
import { Box, Flex, Text } from '@chakra-ui/react'
import { ContainerBase } from '@/components/containers/ContainerBase'
import { Article } from './article'

interface IProps {
  id: string
  current_slug: string
  primary_tag: string
}

export const RelatedArticles = ({ id, current_slug, primary_tag }: IProps) => {
  const { compassContent, getContent } = useBlogCms()
  const router = useRouter()

  useEffect(() => {
    if (!router?.query?.slug) return

    const abortController = new AbortController()
    getContent(
      {
        path: `/content/posts`,
        params: `&limit=3&include=tags,authors&filter=id:-${id}${encodeURIComponent(
          '+'
        )}tag:${primary_tag}`,
      },
      abortController
    )

    return () => {
      abortController.abort()
    }
  }, [router])

  if (!compassContent?.posts?.length) return null

  return (
    <Box bg="brand.600" mt="60px">
      <ContainerBase py="30px">
        <Text fontSize="30px" fontWeight="bold" color="white" px={3}>
          You May Also Like
        </Text>
        <Flex pt="20px" flexWrap={{ base: 'wrap', md: 'unset' }}>
          {compassContent?.posts?.map((article) => {
            if (article?.slug === current_slug) return null
            return <Article key={article?.id} article={article} />
          })}
        </Flex>
      </ContainerBase>
    </Box>
  )
}
